import { useCallback } from 'react'
import { useAuth } from 'contexts/AuthContext'

const useHasPermission = () => {
    const { user } = useAuth()

    return useCallback(permissionSlug => {
        if (!user || !user.permissions) return false

        if (permissionSlug === 'premium') {
            if (user?.is_employee) return true

            return user?.permissions?.some(p => p.slug === permissionSlug)
        }

        if (!user?.is_employee) return true

        return user.permissions.some(p => p.slug === permissionSlug)
    }, [user])
}

export default useHasPermission
